import { API } from "../auth/authApi";

export const getCompanyCategoryApi = () => {
  return API.get("/company-category");
};

export const createCompanyCategoryApi = (data) => {
  return API.post("/company-category", data);
};

export const updateCompanyCategoryApi = (id, data) => {
  return API.put(`/company-category/${id}`, data);
};

export const deleteCompanyCategoryApi = (id) => {
  return API.delete(`/company-category/${id}`);
};